export default function MoonPayLogo({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={17}
      height={17}
      viewBox="0 0 17 17"
      fill="none"
      className={className}
    >
      <path
        fill="#7D00FF"
        d="M13.554 4.928a2.464 2.464 0 1 0 0-4.928 2.464 2.464 0 0 0 0 4.928ZM5.997 16.025a6.004 6.004 0 1 1 .01-12.008 6.004 6.004 0 0 1-.01 12.008Z"
      />
    </svg>
  );
}
